// Text Reverse Tool — reverse characters, words, or lines.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const textReverseTool: Tool = {
  id: "text-reverse",
  name: () => m.rv_tool_name(),
  description: () => m.rv_tool_description(),
  icon: "🔄",
  basePath: "/text-reverse",
  status: "stable",
  tags: ["text", "reverse", "string", "fun"],
  pages: [
    {
      name: () => m.rv_nav_main(),
      path: "/text-reverse",
      description: () => m.rv_nav_main_desc(),
      icon: "🔄",
    },
  ],
};
